import { Document } from '@roc/feature-types';
import { Button, ConfirmationButton, StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { useDocumentStore } from '../../../hooks/useDocumentStore';
import PostDisasterInspection from './postDisasterInspection';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { WithDocumentActions } from '../../../utils/withDocumentActions';

export type PostDisasterInspectionDialogProps = {
  open?: boolean;
  onClose?: () => void;
  loan: any;
  document: Document;
};

export const PostDisasterInspectionDialog = observer((props: PostDisasterInspectionDialogProps) => {
  const { open, onClose, loan, document } = props;
  const taskId = document?.taskId;
  const { documentStore } = useDocumentStore();

  const dialogActions = (
    <>
      <Button
        style={{ marginRight: '8px' }}
        testId="cancel"
        color="default"
        variant="contained"
        onClick={onClose}
      >
        Cancel
      </Button>
      <WithDocumentActions
        document={document}
        component={(btnProps) => (
          <ConfirmationButton
            {...btnProps}
            testId="approve"
            variant="contained"
            color="primary"
            onClick={() => documentStore.documentFormStore?.postDisasterInspectionFormStore.changeFemaDocumentsStatus(onClose)}
            confirmDialogProps={{
              title: 'Confirmation',
              body: 'Are you sure you want to approve the FEMA documents?',
            }}
          >
            Approve
          </ConfirmationButton>
        )}
      />
    </>
  );

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Post Disaster Inspection"
          handleClose={onClose}
          dialogActions={dialogActions}
          dialogContent={
            <PostDisasterInspection
              loan={loan}
              document={document}
            />
          }
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title="Post Disaster Inspection"
          maxWidth="md"
          handleClose={onClose}
          dialogActions={dialogActions}
          dialogContent={
            <PostDisasterInspection
              loan={loan}
              document={document}
            />
          }
          removeContentBox
        />
      )}
    </>
  );
});

export default PostDisasterInspectionDialog;